import React from "react";
import styled from "styled-components";

type Props = {
  children: React.ReactNode;
  margin?: string;
};

export const RecipientsSelectionActionsBar = ({ children, margin }: Props) => {
  return <Container margin={margin}>{children}</Container>;
};

/**
 * Styles
 */

type ContainerProps = Pick<Props, "margin">;

const Container = styled("div").withConfig({ shouldForwardProp: (prop) => !["margin"].includes(prop) })<ContainerProps>`
  display: grid;
  position: relative;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  grid-template-rows: max-content;
  grid-column-gap: 22px;
  margin: ${(props) => props.margin ?? 0};
`;
